import React, { useState, useEffect } from 'react';
import SFTable from '../../../SFComponents/SFTable/SFTable';
import { LinearProgress } from 'react-md';
import moment from 'moment';
import ApiRequestService from '../../../../components/ApiRequestService';
import { Button, Typography } from '@mui/material';
import LoadingSpinner from '../../../../components/LoadingSpinner';

const SFPracticeDetail = ({ selectedCourse, handleRoute, onAddActivityLog, selectedStudentUserName, isInstructor }) => {

    let defaultColuns = [
        {
            id: 'quizName',
            name: 'Assignment Name',
            width: "300px",
        },
        {
            id: 'quizType',
            name: 'Type',
            width: "200px",
        },
        {
            id: 'questionsCompleted',
            name: 'Total Questions Attempted',
            width: "200px",
        },
        {
            id: 'questionsCorrect',
            name: 'Questions Correct',
            width: "200px",
        },
        {
            id: 'actions',
            name: 'Action',
            width: "200px",
            center: true
        },
    ]

    const [columns, setColumns] = useState(defaultColuns)
    const [assignments, setAssignments] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (selectedCourse) {
            setLoading(true)
            getPracticeAssignments()
        }
    }, [selectedCourse, selectedStudentUserName]);

    const getPracticeAssignments = () => {
        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/getPracticeAssignments",
            data: {
                courseID: selectedCourse.course_id,
                sectionID: selectedCourse.section_id,
                userName: selectedStudentUserName
            }
        });

        responsePromise.then(res => {
            if (res && res.data && res.data.data) {
                setAssignments(res.data.data)
            } else {
                setAssignments([])
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    const handleTakeQuizURL = (assignment) => {

        let url = `/takequiz?quiz_id=${assignment.quizID || assignment.quiz_id}&course_id=${assignment.courseID || assignment.course_id}&section_id=${assignment.sectionID || assignment.section_id}&quiz_name=${assignment.quizName || assignment.quiz_name}&quiz_type=${assignment.quizType || assignment.quiz_type}&course_name=${selectedCourse.course_name}`

        const activityPayload = {
            toNomenclatureID: 0, // clicked
            quizID: assignment.quizID,
            subjectID: 0,
            topicID: 0,
            categoryID: 0,
            activityTypeID: 23, // "Practice Again"
        }
        if (onAddActivityLog) {
            onAddActivityLog(activityPayload);
        }

        handleRoute(url);
    }

    const renderRow = (data, index) => {

        function getReadableTime(timeInSec) {
            if (timeInSec <= 60) {
                return `${timeInSec} sec`
            }
            let min = moment.duration(timeInSec, 'seconds').minutes()
            let sec = moment.duration(timeInSec, 'seconds').seconds()

            return `${min}m ${sec}s`
        }

        console.debug("data>>", data)

        return (
            <div>
                <div className='sf-table-row'>
                    <div className='sf-table-row-div' style={{ width: '300px' }}>
                        <center>
                            <Typography fontSize={16} fontWeight={500}>{data.quizName}</Typography>
                        </center>
                    </div>
                    <div className='sf-table-row-div' style={{ width: '200px' }}>
                        <div>
                            <Typography fontSize={16} fontWeight={500}>{data.quizType === 0 ? "Mastery" : "Test"}</Typography>
                        </div>
                    </div>
                    <div className='sf-table-row-div' style={{ width: '200px' }}>
                        <div>
                            <Typography fontSize={22} fontWeight={500}>{data.questionsCompleted}</Typography>
                        </div>
                    </div>
                    <div className='sf-table-row-div' style={{ width: '200px' }}>
                        <div>
                            <Typography fontSize={22} fontWeight={500}>{data.questionsCorrect}</Typography>
                        </div>
                    </div>
                    <div className='sf-table-row-div' style={{ width: '200px' }}>
                        <Button variant='contained' 
                        disabled={isInstructor}
                        onClick={() => {
                            handleTakeQuizURL(data);
                        }}>
                            Practice Again
                        </Button>
                    </div>
                </div>
            </div>
        )
    }



    return (
        <div className='mt-2'>
            {loading ? (
                <div className='sf-fixed-center'>
                    <LoadingSpinner loading={true} />
                </div>
            )
                :
                assignments && assignments.length ?
                    <SFTable
                        columns={columns}
                        tableStyle={{ maxHeight: "560px" }}
                        dataArr={assignments}
                        renderRow={renderRow}
                        handleTakeQuizURL={handleTakeQuizURL}
                    />
                    : (
                        <div className='sf-fixed-center'>
                            <Typography fontSize={24} fontWeight={500}>
                                No Data Found.
                            </Typography>
                        </div>
                    )
            }
        </div>
    );
}

export default SFPracticeDetail;
